import * as React from 'react';
import * as _ from 'lodash-es';

import Paper from '@mui/material/Paper';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Avatar from '@mui/material/Avatar';

import SvgIconAvatar from '../../static/icons/svgIconAvatar';
import LayoutDashboard from 'components/Layout/Dashboard';
import Loader from 'components/Loader/Loader';
import PersonalDetails from 'components/TravelerDetails/PersonalDetails';
import LoyaltyPrograms from 'components/TravelerDetails/LoyaltyPrograms';
import FlightCredits from 'components/TravelerDetails/FlightCredits';
import PaymentMethods from 'components/TravelerDetails/PaymentMethods';
import BookingRules from 'components/TravelerDetails/TravelPolicy/BookingRules';
import BudgetRules from 'components/TravelerDetails/TravelPolicy/BudgetRules';
import NotificationsAndApprovals from 'components/TravelerDetails/TravelPolicy/NotificationsAndApprovals';
import Preferences from 'components/TravelerDetails/TravelPolicy/Preferences';
import Upgrades from 'components/TravelerDetails/TravelPolicy/Upgrades';
import AccountDetails from 'components/TravelerDetails/AccountDetails';
import BookingsTable from 'components/TravelerDetails/BookingsTable';
import Breadcrumbs from 'components/Breadcrumbs/Breadcrumbs';
import Breadcrumb from 'components/Breadcrumbs/Breadcrumb';
import Approvers from 'components/TravelerDetails/TravelPolicy/Approvers';
import ExpenseReportsTable from 'components/TravelerDetails/ExpenseReportsTable';
import DuffelSync from './DuffelSync';
import { hasPermission } from 'helpers/Permission';

import { connectWithRouter } from 'helpers/connectWithRouter';
import { bindActionCreators, Dispatch } from 'redux';
import { getSingle } from 'actions/Travelers/GetSingle';
import { getFrequentFlyers } from 'actions/FrequentFlyers/Get';
import { update as updateTraveler } from 'actions/Travelers/Update';
import {
  getTravelPolicyRules,
  emptyResults as resetTravelPolicy,
  resetSuccessProperty as resetTravelPolicySuccessProp,
} from 'actions/Users/GetTravelPolicyRules';
import { getExpenseReports } from 'actions/Users/GetExpenseReports';
import { get as getCreditCards } from 'actions/User/GetUserCreditCards';
import { getUserFlightCredits } from 'actions/User/GetUserFlightCredits';
import { syncUserFlightCredit } from 'actions/User/SyncUserFlightCredit';
import { getApprovers } from 'actions/Travelers/GetApprovers';
import { getCarLoyaltyProgram } from '../../actions/LoyaltyPrograms/GetCarLoyaltyProgram';
import { getFraudRule } from 'actions/Users/GetUserFraudRule';
import { putFeatures } from 'actions/Features/PutUserBetaFeature';
import { getFeatures, resetFeatures } from 'actions/Features/Get';
import { syncDuffelBooking } from 'actions/Bookings/SyncDuffelBooking';
import BetaFeatures from 'components/Features/BetaFeatures';
import { TB_BLACKBOX_ENV } from '../../configs/Api';
import Notes from 'components/Notes/Notes';
import { PermissionTypes, ResourceTypes } from '../../constants';

const styles = require('./styles.pcss');

import { ReduxState, Traveler as TravelerType } from 'reducers/types';
import BookTrain from 'components/BookTrain/BookTrain';
import { postTrainBooking } from 'actions/Bookings/PostTrainBooking';
import SupportLoginButton from 'components/SupportLogin/SupportLogin';
import { NavigateFunction } from 'react-router-dom';

interface RouteParams {
  travelerId?: string;
  userId?: string;
}

type Props = {
  travelerId?: string;
  getSingle: Function;
  postTrainBooking: Function;
  updateTraveler: Function;
  getFrequentFlyers: Function;
  traveler: TravelerType;
  isLoading: boolean;
  isLoadingCC: any;
  getTravelPolicyRules: Function;
  getExpenseReports: Function;
  user: any;
  userLoading: any;
  travelPolicy: any;
  resetTravelPolicy: Function;
  resetTravelPolicySuccessProp: Function;
  userId: any;
  travelers: any;
  getCreditCards: Function;
  getUserFlightCredits: Function;
  getApprovers: Function;
  approversIsLoading: boolean;
  approversList: any;
  carLoyaltyProgram: any;
  expenseReports: any;
  getCarLoyaltyProgram: Function;
  getFraudRule: Function;
  syncDuffelBooking: Function;
  getFeatures: Function;
  resetFeatures: Function;
  putFeatures: Function;
  isLoadingFeatures: boolean;
  features: any;
  isLoadingDuffelSync: boolean;
  isLoadingBooking: boolean;
  navigate: NavigateFunction;
  params: RouteParams;
};

enum TabTypes {
  travelPolicy = 'travel-policy',
  creditCards = 'credit-cards',
  profile = 'profile',
  bookings = 'bookings',
  expenses = 'expenses',
  account = 'account',
  beta = 'beta',
}

export enum TravelPolicyTabTypes {
  flight = 'flight',
  car = 'car',
  hotel = 'hotel',
}

enum UserDetailTabTypes {
  profile = 'profile',
  beta = 'beta',
  payment = 'credit-cards',
  travelPolicy = 'travel-policy',
  bookings = 'bookings',
  expenses = 'expenses',
  account = 'account',
}

const userDetailTabTypeLabels = {
  [UserDetailTabTypes.profile]: 'Profile',
  [UserDetailTabTypes.beta]: 'Beta',
  [UserDetailTabTypes.payment]: 'Payment',
  [UserDetailTabTypes.travelPolicy]: 'Travel Policy',
  [UserDetailTabTypes.bookings]: 'Bookings',
  [UserDetailTabTypes.expenses]: 'Expenses',
  [UserDetailTabTypes.account]: 'Account',
};

const travelPolicyTabTypeLabels = {
  [TravelPolicyTabTypes.flight]: 'Flights',
  [TravelPolicyTabTypes.car]: 'Cars',
  [TravelPolicyTabTypes.hotel]: 'Hotels',
};

type State = {
  activeTab: TabTypes;
  travelPolicyTab: TravelPolicyTabTypes;
};

class UserDetails extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    const searchParams = new URLSearchParams(window.location.search);
    const activeTab =
      (searchParams.get('activeTab') as TabTypes) || TabTypes.profile;

    this.state = {
      activeTab: activeTab,
      travelPolicyTab: TravelPolicyTabTypes.flight,
    };

    this.onTabChange = this.onTabChange.bind(this);

    let param: any = {
      scopeType: 'user',
    };

    if (TB_BLACKBOX_ENV === 'production') {
      param.confidence = TB_BLACKBOX_ENV;
    }

    if (hasPermission(ResourceTypes.features, PermissionTypes.read)) {
      this.props.getFeatures(param);
    }
  }

  userId = this.props.params?.userId;

  navigate = (path: string) => {
    this.props.navigate(path);
  };
  onTabChange(event: any, value: any) {
    window.history.pushState({}, '', `?activeTab=${value}`);

    if (
      value === TabTypes.expenses &&
      hasPermission('expenseReport', PermissionTypes.read)
    ) {
      this.props.getExpenseReports(this.userId);
    }

    this.setState({
      activeTab: value,
    });
  }

  componentDidMount() {
    this.props.getFraudRule(this.userId);
    this.props.resetTravelPolicy();
    this.props.getFrequentFlyers();
    this.props.getCarLoyaltyProgram();
    if (hasPermission(ResourceTypes.bookings, PermissionTypes.read)) {
      this.props.getUserFlightCredits(this.userId);
    }
    if (this.props.travelerId && this.props.travelerId !== null) {
      this.props.getSingle(this.props.travelerId);
    }
  }

  componentWillUnmount() {
    this.props.resetTravelPolicy();
    this.props.resetFeatures();
  }

  componentDidUpdate = (prevProps: Props, prevState: State) => {
    if (prevState.activeTab !== this.state.activeTab) {
      this.navigate(`?activeTab=${this.state.activeTab}`);
    }

    const isTravelerIdUndefined =
      !this.props.travelerId || this.props.travelerId === null;
    if (
      this.props.travelers?.travelers?.length &&
      prevProps.travelers != this.props.travelers &&
      isTravelerIdUndefined
    ) {
      this._onFetchTraveler();
    }

    if (
      hasPermission(ResourceTypes.users, PermissionTypes.read) &&
      !this.props.travelPolicy.success &&
      !this.props.travelPolicy.isLoading
    ) {
      this._onFetchTravelPolicyRules();
    }
  };

  _onFetchTravelPolicyRules = () => {
    this.props.getApprovers(this.userId);
    this.props.getTravelPolicyRules(this.userId);
  };

  _onFetchTraveler = () => {
    let traveler = _.find(this.props.travelers.travelers, (t) => t.isPrimary);
    if (traveler !== undefined && traveler.hasOwnProperty('id')) {
      this.props.getSingle(traveler.id);
    }
  };

  _onGetReadPermissions() {
    const loginData: any = localStorage.getItem('login_data');

    if (loginData !== null) {
      const loginDataperse = JSON.parse(loginData);
      const userPermissions = _.get(loginDataperse, 'userPermissions', null);
      const updatePermission = _.result(
        _.find(userPermissions, (p) => p.resource == ResourceTypes.travelers),
        PermissionTypes.update,
      );
      const createPermission = _.result(
        _.find(userPermissions, (p) => p.resource == ResourceTypes.travelers),
        PermissionTypes.create,
      );
      const readPermission = _.result(
        _.find(userPermissions, (p) => p.resource == ResourceTypes.travelers),
        PermissionTypes.read,
      );

      if (!updatePermission && !createPermission && readPermission) {
        return true;
      }
    }

    return false;
  }

  _onUpdateTravelerInfo = (traveler: any) => {
    return {
      travelerId: traveler.id,
      firstName: traveler.firstName,
      middleName: traveler.middleName,
      lastName: traveler.lastName,
      gender: traveler.gender,
      birthDate: traveler.birthDate,
      knownTravelerNumber: traveler.knownTravelerNumber,
      email: traveler.email,
      phone: {
        countryCode: traveler.phoneCountryCode,
        number: traveler.phoneNumber,
      },
      passportInfo: {
        passCountry: traveler.passCountry,
        passNumber: traveler.passNumber,
        passExpiry: traveler.passExpiry,
      },
    };
  };

  _onUpdateFrequentFlyers = (frequentFlyers: any) => {
    const clonedTraveler = _.clone(this.props.traveler);
    const updatedTravelerInfo = this._onUpdateTravelerInfo(clonedTraveler);

    this.props.updateTraveler({
      ...updatedTravelerInfo,
      frequentFlyer: frequentFlyers,
    });
  };

  _onUpdateHotelLoyaltyProgram = (hotelLoyaltyPrograms: any) => {
    const clonedTraveler = _.clone(this.props.traveler);
    const updatedTravelerInfo = this._onUpdateTravelerInfo(clonedTraveler);

    this.props.updateTraveler({
      ...updatedTravelerInfo,
      frequentFlyer: clonedTraveler.frequentFlyer,
      hotelLoyaltyPrograms: hotelLoyaltyPrograms,
    });
  };

  _onUpdateCarLoyaltyProgram = (carLoyalty: any) => {
    const clonedTraveler = _.clone(this.props.traveler);
    const updatedTravelerInfo = this._onUpdateTravelerInfo(clonedTraveler);

    this.props.updateTraveler({
      ...updatedTravelerInfo,
      carLoyaltyPrograms: carLoyalty,
    });
  };

  _onCreditCardsChanged = () => this.props.getCreditCards(this.userId);

  _onRenderCustomerDetails = () => {
    const hasCreatePermission = hasPermission(
      ResourceTypes.travelers,
      PermissionTypes.create,
    );

    const newTraveler =
      _.get(this.props.travelers, ResourceTypes.travelers, []).length == 0 &&
      hasCreatePermission;

    const isReadOnly = this._onGetReadPermissions();
    return (
      <PersonalDetails
        readOnly={isReadOnly}
        traveler={this.props.traveler}
        newTraveler={newTraveler}
        userId={this.userId}
      />
    );
  };

  _onRenderFlightCredits = () =>
    _.get(this.props, 'traveler', false) && (
      <FlightCredits
        hasPermission={hasPermission(
          ResourceTypes.travelers,
          PermissionTypes.update,
        )}
        syncUserFlightCredit={this.props.syncUserFlightCredit}
        isSyncingFlightCredit={this.props.isSyncingFlightCredit}
        flightCredits={_.get(this.props.user, 'flightCredits', [])}
      />
    );

  _onRenderNotes = () => (
    <Notes
      id={this.userId}
      type="user"
      entity={this.props.user}
    />
  );

  _onHandleFeatureChange = (feature: any, checked: boolean) => {
    this.props.putFeatures({
      userId: _.get(this, 'userId', null),
      featureName: feature.name,
      confidence: feature.confidence,
      enabled: checked,
      orgId: _.get(this.props.user?.organizations[0], 'id', null),
    });
  };

  _onHandleTravelPolicyTabChange = (
    _: any,
    travelPolicyTab: TravelPolicyTabTypes,
  ) =>
    this.setState({
      travelPolicyTab,
    });

  _onRenderContent() {
    const { activeTab } = this.state;
    if (activeTab === TabTypes.profile) {
      return (
        <div>
          {this._onRenderCustomerDetails()}
          {_.get(this.props, 'traveler', false) && (
            <LoyaltyPrograms
              travelerFrequentFlyerData={_.get(
                this.props,
                'traveler.frequentFlyer',
                [],
              )}
              travelerHotelLoyaltyProgram={_.get(
                this.props,
                'traveler.hotelLoyaltyPrograms',
                [],
              )}
              updateHotelProgram={this._onUpdateHotelLoyaltyProgram}
              update={this._onUpdateFrequentFlyers}
              hasPermission={hasPermission(
                ResourceTypes.bookings,
                PermissionTypes.update,
              )}
              carLoyaltyProgram={this.props.carLoyaltyProgram}
              travelerCarLoyaltyProgram={_.get(
                this.props,
                'traveler.carLoyalty',
                [],
              )}
              updateCarProgram={this._onUpdateCarLoyaltyProgram}
            />
          )}
          {this._onRenderFlightCredits()}
          {this._onRenderNotes()}
        </div>
      );
    }

    if (activeTab === TabTypes.creditCards) {
      return (
        <div>
          <PaymentMethods
            creditCards={_.get(this.props.user, 'creditCards', [])}
            userId={this.userId}
            onCreditCardsChanged={this._onCreditCardsChanged}
          />
        </div>
      );
    }

    if (activeTab === TabTypes.travelPolicy) {
      const { travelPolicyTab } = this.state;

      const { travelPolicy, approversIsLoading, approversList } =
        this.props || {};

      const { isLoading, userTravelPolicyRules } = travelPolicy || {};
      const flight = _.get(userTravelPolicyRules?.policyRules, 'flight', {});
      const hotel = _.get(userTravelPolicyRules?.policyRules, 'hotel', {});
      const car = _.get(userTravelPolicyRules?.policyRules, 'car', {});
      const budgetPolicy = _.get(userTravelPolicyRules, 'budgetPolicy', {});


      return (
        <div className={styles.travelPolicyRulesRow}>
          <div className={styles.travelPolicyRules}>
            <Paper className={styles.travelPolicyTabsContainer}>
              <Tabs
                value={travelPolicyTab}
                indicatorColor="primary"
                textColor="primary"
                className={styles.travelPolicyTabs}
                onChange={this._onHandleTravelPolicyTabChange}
              >
                {Object.values(TravelPolicyTabTypes).map(
                  (tabType: TravelPolicyTabTypes) => (
                    <Tab
                      key={tabType}
                      disableRipple
                      label={travelPolicyTabTypeLabels[tabType]}
                      value={tabType}
                    />
                  ),
                )}
              </Tabs>
            </Paper>
            <BudgetRules
              isLoading={isLoading}
              product={travelPolicyTab}
              budgetPolicy={budgetPolicy}
            />
            <BookingRules
              isLoading={isLoading}
              product={travelPolicyTab}
              hotelPolicy={hotel}
              flightPolicy={flight}
              carPolicy={car}
            />
            <NotificationsAndApprovals
              isLoading={isLoading}
              product={travelPolicyTab}
              hotelPolicy={hotel}
              flightPolicy={flight}
              carPolicy={car}
            />
            <Upgrades
              isLoading={isLoading}
              product={travelPolicyTab}
              flightPolicy={flight}
            />
            <Preferences
              isLoading={isLoading}
              product={travelPolicyTab}
              flightPolicy={flight}
              carPolicy={car}
            />
          </div>
          <div>
            <Approvers
              isLoading={approversIsLoading}
              approversList={approversList}
            />
          </div>
        </div>
      );
    }

    if (activeTab === TabTypes.bookings) {
      return (
        <div>
          <Paper className={styles.syncPaper}>
            <DuffelSync
              isDisabled={this.props.isLoadingDuffelSync}
              userId={this.userId}
              sync={this.props.syncDuffelBooking}
            />
          </Paper>
          <Paper className={styles.syncPaper}>
            <BookTrain
              isDisabled={this.props.isLoadingBooking}
              userId={this.userId}
              onSubmit={this.props.postTrainBooking}
            />
          </Paper>
          <Paper className={styles.paper}>
            <BookingsTable userId={this.userId} />
          </Paper>
        </div>
      );
    }

    if (activeTab === TabTypes.expenses) {
      return (
        <Paper className={styles.paper}>
          <ExpenseReportsTable userId={this.userId} />
        </Paper>
      );
    }

    if (activeTab === TabTypes.account) {
      return (
        <div>
          <AccountDetails
            user={this.props.user}
            userId={this.userId}
          />
        </div>
      );
    }

    if (activeTab === TabTypes.beta) {
      const features = _.get(this.props, 'features', []);

      return (
        <BetaFeatures
          features={features}
          userId={_.get(this, 'userId', null)}
          type="user"
          onHandleChange={this._onHandleFeatureChange}
        />
      );
    }

    return null;
  }

  renderAvatar = () => {
    if (this.props.isLoading || this.props.userLoading) {
      return (
        <Avatar
          alt="Avatar"
          className={styles.avatar}
        ></Avatar>
      );
    }

    if (
      _.get(this.props.user, 'avatar', '').length > 1 &&
      _.get(this.props.user, 'avatar', '') != null
    ) {
      return (
        <Avatar
          alt="Avatar"
          src={_.get(this.props.user, 'avatar', '')}
          className={styles.avatar}
        />
      );
    }

    const firstName =
      _.get(this.props, 'user.firstName', null) !== null
        ? _.get(this.props, 'user.firstName', null)
        : '';
    const lastName =
      _.get(this.props, 'user.lastName', null) !== null
        ? _.get(this.props, 'user.lastName', null)
        : '';

    const name = `${firstName} ${lastName}`;
    return name.trim() === '' ? (
      <SvgIconAvatar
        width={50}
        height={50}
      />
    ) : (
      <Avatar
        alt="avatar"
        className={styles.avatarLetter}
      >
        {firstName.charAt(0)}
        {lastName.charAt(0)}
      </Avatar>
    );
  };

  _onGetUserName = () => {
    let name = `${_.get(this.props.user, 'firstName', '')} ${_.get(
      this.props.user,
      'lastName',
      '',
    )}`;

    return name.trim() === '' ? _.get(this.props.user, 'email', '') : name;
  };

  _onRenderFraudStatus = () => {
    const userFraudStatus = _.get(this.props, 'fraudCheck');
    const orgFraudStatus = _.get(this.props, 'user.organizations', '')?.[0]
      ?.fraudStatus;

    if (userFraudStatus === 'emailBlockList') {
      return <div className={styles.fraud}>Fraud</div>;
    }

    if (orgFraudStatus === 'fraudulent') {
      return <div className={styles.fraud}>Fraud Org</div>;
    }

    return;
  };

  render() {
    let title =
      _.get(this.props, 'traveler.firstName', '') +
      ' ' +
      _.get(this.props, 'traveler.lastName', '');

    if (
      ![
        TabTypes.profile,
        TabTypes.creditCards,
        TabTypes.travelPolicy,
        TabTypes.beta,
      ].includes(this.state.activeTab)
    ) {
      title = 'Bookings for ' + title;
    }

    const orgs = _.uniqBy(_.get(this.props.user, 'organizations', []), 'id');
    const channels = _.get(this.props.user, 'channels', []);

    return (
      <LayoutDashboard>
        {(this.props.isLoading ||
          this.props.userLoading ||
          this.props.isLoadingCC) && (
          <div className={styles.detailsLoaderContainer}>
            <Loader
              visible
              id="userLoader"
            />
          </div>
        )}

        <div className="pageWrapper">
          <Breadcrumbs className={styles.breadcrumbs}>
            <Breadcrumb
              arrow
              name="Lookup"
            />
            <Breadcrumb name={this._onGetUserName()} />
          </Breadcrumbs>
          <div className={styles.header}>
            <div className={styles.avatarAndName}>
              <div className={styles.avatarContainer}>
                {this.renderAvatar()}
              </div>
              <div>
                <div className={styles.nameAndBrexContainer}>
                  <h1 className={styles.travelerName}>
                    {this._onGetUserName()}
                  </h1>

                  <div className={styles.chips}>
                    {_.get(this.props.user, 'agency.friendlyName', null) !==
                      null && (
                      <div
                        style={{
                          background: _.get(
                            this.props.user,
                            'agency.uiSettings.primaryColor',
                            '#6d717a',
                          ),
                        }}
                        className={styles.chip}
                      >
                        {this.props.user.agency.friendlyName}
                      </div>
                    )}
                    {channels.filter(Boolean).map((channel: any) => (
                      <div
                        key={channel.id}
                        className={`${styles.chip}`}
                        style={{ background: _.get(channel, 'uiSettings.primaryColor', '#6d717a') }}
                      >
                        {channel.friendlyName}
                      </div>
                    ))}
                    {_.get(this.props.user, 'status', '') == 'disabled' && (
                      <div className={`${styles.chip} ${styles.terminated}`}>
                        Terminated
                      </div>
                    )}
                    {this._onRenderFraudStatus()}
                    {hasPermission(
                      ResourceTypes.customerLogin,
                      PermissionTypes.read,
                    ) &&
                      this.userId && (
                        <SupportLoginButton userId={this.userId} />
                      )}
                  </div>
                </div>

                <div className={styles.companyName}>
                  {orgs.map((organization: any, i: number) => {
                    const compName = _.get(organization, 'name', '');

                    return (
                      <React.Fragment key={organization?.id}>
                        <div
                          key={_.get(organization, 'id', '')}
                          className={styles.link}
                          onClick={() => {
                            this.navigate(
                              `/company/${_.get(organization, 'id', '')}`,
                            );
                          }}
                        >
                          {compName}{' '}
                        </div>
                        {i + 1 < orgs.length && ', '}
                      </React.Fragment>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>

          <Tabs
            className={styles.tabs}
            value={this.state.activeTab}
            indicatorColor="primary"
            textColor="primary"
            onChange={this.onTabChange}
          >
            {hasPermission(ResourceTypes.travelers, PermissionTypes.read) && (
              <Tab
                className={styles.tab}
                label={userDetailTabTypeLabels[UserDetailTabTypes.profile]}
                value={UserDetailTabTypes.profile}
              />
            )}
            {hasPermission(ResourceTypes.features, PermissionTypes.read) && (
              <Tab
                disableRipple
                className={styles.tab}
                label={userDetailTabTypeLabels[UserDetailTabTypes.beta]}
                value={UserDetailTabTypes.beta}
              />
            )}
            {hasPermission(ResourceTypes.creditCards, PermissionTypes.read) && (
              <Tab
                className={styles.tab}
                id="payment"
                label={userDetailTabTypeLabels[UserDetailTabTypes.payment]}
                value={UserDetailTabTypes.payment}
              />
            )}
            {hasPermission(ResourceTypes.users, PermissionTypes.read) && (
              <Tab
                className={styles.tab}
                label={userDetailTabTypeLabels[UserDetailTabTypes.travelPolicy]}
                value={UserDetailTabTypes.travelPolicy}
              />
            )}
            {hasPermission(ResourceTypes.bookings, PermissionTypes.read) && (
              <Tab
                className={styles.tab}
                label={userDetailTabTypeLabels[UserDetailTabTypes.bookings]}
                value={UserDetailTabTypes.bookings}
              />
            )}
            {hasPermission(
              ResourceTypes.expenseReport,
              PermissionTypes.read,
            ) && (
              <Tab
                className={styles.tab}
                label={userDetailTabTypeLabels[UserDetailTabTypes.expenses]}
                value={UserDetailTabTypes.expenses}
              />
            )}
            {hasPermission(ResourceTypes.users, PermissionTypes.read) && (
              <Tab
                className={styles.tab}
                id="account-tab"
                label={userDetailTabTypeLabels[UserDetailTabTypes.account]}
                value={UserDetailTabTypes.account}
              />
            )}
          </Tabs>

          {this._onRenderContent()}
        </div>
      </LayoutDashboard>
    );
  }
}

// Wire up redux state to component
function mapStateToProps(state: ReduxState) {
  return {
    traveler: state.traveler.traveler,
    isLoading: state.traveler.isLoading,
    user: state.user.user,
    isLoadingCC: state.user.isLoadingCC,
    userLoading: state.user.isLoading,
    travelPolicy: state.userTravelPolicyRules,
    travelers: state.travelers,
    approversList: state.approvers.users,
    approversIsLoading: state.approvers.isLoading,
    carLoyaltyProgram: state.carLoyaltyPrograms.carLoyaltyProgram,
    expenseReports: state.userExpenseReports.expenseReports,
    fraudCheck: state.userFraudRule.rule,
    features: state.betaFeatures.features,
    isSyncingFlightCredit: (state.user as any).isSyncingFlightCredit || false,
    isLoadingFeatures: state.betaFeatures.isLoading,
    isLoadingDuffelSync: state.syncDuffelbooking.isLoading,
    isLoadingBooking: state.booking.isLoading,
  };
}

// Wire up redux dispatch functions
function mapDispatchToProps(dispatch: Dispatch) {
  return bindActionCreators(
    {
      getSingle,
      getFrequentFlyers,
      updateTraveler,
      getTravelPolicyRules,
      getExpenseReports,
      resetTravelPolicy,
      resetTravelPolicySuccessProp,
      getCreditCards,
      getUserFlightCredits,
      syncUserFlightCredit,
      getApprovers,
      getCarLoyaltyProgram,
      getFraudRule,
      resetFeatures,
      putFeatures,
      getFeatures,
      syncDuffelBooking,
      postTrainBooking,
    },
    dispatch,
  );
}

// Connect it to Redux
export default connectWithRouter(
  mapStateToProps,
  mapDispatchToProps,
)(UserDetails);
